module.exports = "<cat-section-header\n  [breadcrumbs]=\"breadcrumbs\"\n  [optionItems]=\"featureOptions\"\n></cat-section-header>\n<cat-section-content>\n  <router-outlet></router-outlet>\n</cat-section-content>\n\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/features/features.component.html
// module id = ../../../../../src/app/modules/features/components/features/features.component.html
// module chunks = main